export default function EnvironmentalBenefits() {
  const benefits = [
    {
      icon: 'ri-water-percent-line',
      title: '水資源の保護',
      description: '閉鎖循環システムにより、水の使用量を従来の養殖方法と比較して90%以上削減。貴重な水資源を守ります。',
      impact: '年間数万トンの水を節約',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-leaf-line',
      title: '環境汚染ゼロ',
      description: '排水を外部に放出しないため、河川や海洋への汚染がゼロ。地域の水環境を保全します。',
      impact: '排水による環境負荷ゼロ',
      color: 'from-[#2D7A3E] to-[#4CAF50]'
    },
    {
      icon: 'ri-plant-line',
      title: '生態系への配慮',
      description: '自然環境から隔離された施設での養殖により、野生生物への影響を最小限に抑えます。',
      impact: '生態系保護に貢献',
      color: 'from-emerald-500 to-teal-500'
    },
    {
      icon: 'ri-earth-line',
      title: '持続可能な生産',
      description: '環境負荷を抑えながら安定した食料生産を実現。次世代に豊かな環境を残します。',
      impact: '持続可能な食料供給',
      color: 'from-green-600 to-lime-500'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#F5F9F6] to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
            <i className="ri-leaf-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">環境への配慮</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            環境負荷を最小限に抑える<br className="md:hidden" />養殖技術
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            従来の養殖方法と比較して、環境への影響を大幅に削減。<br className="hidden md:block" />
            持続可能な水産生産を実現します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-20">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg border border-[#E8F5E9] hover:shadow-2xl transition-all duration-300"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${benefit.color} rounded-xl flex items-center justify-center mb-6`}>
                <i className={`${benefit.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-6">{benefit.description}</p>
              <div className="pt-4 border-t border-[#E8F5E9]">
                <div className="flex items-center">
                  <i className="ri-checkbox-circle-line text-[#2D7A3E] text-xl mr-2"></i>
                  <p className="text-sm font-semibold text-[#2D7A3E]">{benefit.impact}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-[#1A2332] mb-6">
              従来の養殖との比較
            </h3>
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-md border border-[#E8F5E9]">
                <div className="flex items-start justify-between mb-3">
                  <h4 className="text-lg font-bold text-[#1A2332]">水使用量</h4>
                  <span className="px-3 py-1 bg-[#E8F5E9] text-[#2D7A3E] text-sm font-semibold rounded-full whitespace-nowrap">90%削減</span>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">従来の養殖</span>
                    <div className="flex-1 mx-4 bg-gray-200 h-2 rounded-full">
                      <div className="bg-gray-400 h-2 rounded-full" style={{ width: '100%' }}></div>
                    </div>
                    <span className="text-gray-600 font-semibold">100%</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-[#2D7A3E] font-semibold">循環型システム</span>
                    <div className="flex-1 mx-4 bg-gray-200 h-2 rounded-full">
                      <div className="bg-[#2D7A3E] h-2 rounded-full" style={{ width: '10%' }}></div>
                    </div>
                    <span className="text-[#2D7A3E] font-semibold">10%</span>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-[#E8F5E9]">
                <div className="flex items-start justify-between mb-3">
                  <h4 className="text-lg font-bold text-[#1A2332]">環境排水</h4>
                  <span className="px-3 py-1 bg-[#E8F5E9] text-[#2D7A3E] text-sm font-semibold rounded-full whitespace-nowrap">100%削減</span>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">従来の養殖</span>
                    <div className="flex-1 mx-4 bg-gray-200 h-2 rounded-full">
                      <div className="bg-gray-400 h-2 rounded-full" style={{ width: '100%' }}></div>
                    </div>
                    <span className="text-gray-600 font-semibold">大量排水</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-[#2D7A3E] font-semibold">循環型システム</span>
                    <div className="flex-1 mx-4 bg-gray-200 h-2 rounded-full">
                      <div className="bg-[#2D7A3E] h-2 rounded-full" style={{ width: '0%' }}></div>
                    </div>
                    <span className="text-[#2D7A3E] font-semibold">ゼロ</span>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-[#E8F5E9]">
                <div className="flex items-start justify-between mb-3">
                  <h4 className="text-lg font-bold text-[#1A2332]">生産安定性</h4>
                  <span className="px-3 py-1 bg-[#E8F5E9] text-[#2D7A3E] text-sm font-semibold rounded-full whitespace-nowrap">365日安定</span>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">従来の養殖</span>
                    <span className="text-gray-600">季節変動あり</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-[#2D7A3E] font-semibold">循環型システム</span>
                    <span className="text-[#2D7A3E] font-semibold">年間安定生産</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/bba32d689c88021d44197d32a2b25db5.jpg"
                alt="従来の養殖と循環型システムの比較"
                className="w-full h-[700px] object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}